import { FunctionComponent } from "react";

import { PaginationContextProvider } from "@ds-cps/ui";

import { SearchOrganizationsContextProvider } from "./search/context/SearchOrganizationsContextProvider";
import { SectionWithSearchOrganizations } from "./search/SectionWithSearchOrganizations";
import { SectionWithOrganizationsTable } from "./table/SectionWithOrganizationsTable";

export const OrganizationsOverview: FunctionComponent = () => {
  return (
    <div
      data-testid="organization-overview-table-container"
      className="mt-3 rounded-md bg-white p-4 shadow-[0_4px_20px_0_rgba(0,0,0,0.1)]"
    >
      <SearchOrganizationsContextProvider>
        <PaginationContextProvider>
          <SectionWithSearchOrganizations />
          <SectionWithOrganizationsTable />
        </PaginationContextProvider>
      </SearchOrganizationsContextProvider>
    </div>
  );
};
